export const text = {
    errorMsg: "مشکلی پیش آمده، لطفا دوباره تلاش کنید.",
}
